export default "__VITE_ASSET__CiurvCfu__"